import ApplicationState from "@/state/ApplicationState"
import SessionState from "@/state/SessionState"
import FieldState from "@/state/FieldState"
import ProviderState from "@/state/ProviderState"
import ValidationState from "@/state/ValidationState"
import LearnHowState from "@/state/LearnHowState"
import ProveState from "@/state/ProveState"

export const applicationState = ApplicationState
export const fieldState = FieldState
export const learnHowState = LearnHowState
export const providerState = ProviderState
export const sessionState = SessionState
export const validationState = ValidationState
export const proveState = ProveState

export class applyState {}
